import { render, staticRenderFns } from "./BaseItemCompetitionSmall.vue?vue&type=template&id=0588cf44&scoped=true&"
import script from "./BaseItemCompetitionSmall.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetitionSmall.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemCompetitionSmall.vue?vue&type=style&index=0&id=0588cf44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588cf44",
  null
  
)

export default component.exports